// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   ListGroup,
//   ListGroupItem,
// } from "reactstrap";
// import { jwtDecode } from "jwt-decode";

// import Navbar from "../../../Components/Navbar";
// import { URL } from "../../../config";
// import ExtendTimeModal from "../Modal/ExtendTimeModal";
// import "./notificationsPage.css";

// // Helper function to convert date into a "relative" time string
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);

//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const NotificationsPage = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedOrderId, setSelectedOrderId] = useState(null);
//   const [activeTab, setActiveTab] = useState("all");

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;

//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setNotifications(data);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//   }, []);

//   // Handle "Extend Time" button
//   const handleExtendClick = (notif) => {
//     const orderId = notif.orderId || notif.id.split("-")[1];
//     setSelectedOrderId(orderId);
//     setModalOpen(true);
//   };

//   // Close modal
//   const handleModalClose = () => {
//     setModalOpen(false);
//   };

//   // Example: after extension, remove or update notification
//   const handleExtensionSuccess = () => {
//     setNotifications((prev) =>
//       prev.filter((notif) => notif.orderId !== selectedOrderId)
//     );
//   };

//   // Filtering logic
//   const filteredNotifications = notifications.filter((notif) => {
//     if (activeTab === "all") return true;
//     if (activeTab === "unread") return !notif.isRead;
//     if (activeTab === "orders") return notif.category === "orders";
//     if (activeTab === "service") return notif.category === "service";
//     if (activeTab === "system") return notif.category === "system";
//     return true;
//   });

//   // Mark all as read
//   const markAllAsRead = () => {
//     // In a real app, call an API to mark them all as read
//     setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
//   };

//   // Switch active filter tab
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <>
//       <Navbar />

//       {/* Main container */}
//       <Container className="usernotificationpage-container">
//         {/* Page header card */}
//         <Row>
//           <Col>
//             <Card className="mb-3">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0 fw-semibold">Notifications</h5>
//                 <Button
//                   className="usernotification-btn-markallread btn-sm"
//                   onClick={markAllAsRead}
//                 >
//                   <i className="fas fa-check-double me-1"></i>
//                   Mark all as read
//                 </Button>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>

//         {/* Filter tabs/buttons */}
//         <Row>
//           <Col>
//             <div className="d-flex flex-wrap gap-2 mb-3 usernotification-filter">
//               <Button
//                 color={activeTab === "all" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("all")}
//               >
//                 All
//               </Button>
//               <Button
//                 color={activeTab === "unread" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("unread")}
//               >
//                 Unread
//               </Button>
//               <Button
//                 color={activeTab === "orders" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("orders")}
//               >
//                 Orders
//               </Button>
//               <Button
//                 color={activeTab === "service" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("service")}
//               >
//                 Services
//               </Button>
//               <Button
//                 color={activeTab === "system" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("system")}
//               >
//                 System
//               </Button>
//             </div>
//           </Col>
//         </Row>

//         {/* Notifications list */}
//         <Row>
//           <Col>
//             <Card className="usernotification-container">
//               <CardBody>
//                 {filteredNotifications.length > 0 ? (
//                   <ListGroup>
//                     {filteredNotifications.map((notif) => {
//                       // Determine icon class and wrapper color
//                       let iconClass = "fas fa-bell";
//                       let iconWrapperClass = "usernotification-icon-blue";
//                       if (notif.category === "orders") {
//                         iconClass = "fas fa-clipboard-check";
//                         iconWrapperClass = "usernotification-icon-blue";
//                       } else if (notif.category === "service") {
//                         iconClass = "fas fa-tools";
//                         iconWrapperClass = "usernotification-icon-green";
//                       } else if (notif.category === "system") {
//                         iconClass = "fas fa-exclamation-circle";
//                         iconWrapperClass = "usernotification-icon-red";
//                       }

//                       return (
//                         <ListGroupItem
//                           key={notif.id}
//                           className={`usernotification-item position-relative ${
//                             notif.isRead ? "" : "usernotification-unread"
//                           }`}
//                         >
//                           <div className="d-flex align-items-start">
//                             {/* Icon */}
//                             <div
//                               className={`usernotification-icon-wrapper ${iconWrapperClass} me-3`}
//                             >
//                               <i className={iconClass}></i>
//                             </div>

//                             {/* Text content */}
//                             <div className="usernotification-content flex-grow-1">
//                               <div className="usernotification-title fw-semibold mb-1">
//                                 {notif.title || "Notification Title"}
//                               </div>
//                               <div className="usernotification-message mb-1">
//                                 {notif.message}
//                               </div>
//                               <div className="usernotification-time">
//                                 {timeSince(notif.createdAt)}
//                               </div>
//                             </div>

//                             {/* Right side: optional "Extend Time" button */}
//                             <div className="ms-auto d-flex align-items-center gap-2">
//                               <Button
//                                 color="outline-secondary"
//                                 size="sm"
//                                 onClick={() => handleExtendClick(notif)}
//                               >
//                                 Extend Time
//                               </Button>

//                               {/* Ellipsis icon (like "More actions") */}
//                               <div className="usernotification-actions">
//                                 <i className="fas fa-ellipsis-v text-muted"></i>
//                               </div>
//                             </div>
//                           </div>
//                         </ListGroupItem>
//                       );
//                     })}
//                   </ListGroup>
//                 ) : (
//                   <p className="text-center mb-0">No notifications found</p>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       {/* Extend Time Modal */}
//       {modalOpen && (
//         <ExtendTimeModal
//           orderId={selectedOrderId}
//           onClose={handleModalClose}
//           onExtensionSuccess={handleExtensionSuccess}
//         />
//       )}
//     </>
//   );
// };

// export default NotificationsPage;

// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   ListGroup,
//   ListGroupItem,
// } from "reactstrap";
// import { jwtDecode } from "jwt-decode";
// import Navbar from "../../../Components/Navbar";
// import { URL } from "../../../config";
// import ExtendTimeModal from "../Modal/ExtendTimeModal";
// import "./notificationsPage.css";

// // Helper function to convert date into a "relative" time string
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);

//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const NotificationsPage = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   // We now store an object containing both orderId and serviceType
//   const [selectedOrderInfo, setSelectedOrderInfo] = useState(null);
//   const [activeTab, setActiveTab] = useState("all");

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;

//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setNotifications(data);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//   }, []);

//   // Handle "Extend Time" button: extract orderId and serviceType from notification id.
//   const handleExtendClick = (notif) => {
//     // Assume notif.id is formatted like "electrician-55", "homeclean-55", or "plumber-55"
//     const parts = notif.id.split("-");
//     const serviceType =
//       parts[0] === "electrician"
//         ? "electrician"
//         : parts[0] === "homeclean"
//         ? "home cleaning"
//         : parts[0] === "plumber"
//         ? "plumber"
//         : "";
//     // Use the second part as orderId if notif.orderId is not already set.
//     const orderId = notif.orderId || parts[1];
//     setSelectedOrderInfo({ orderId, serviceType });
//     setModalOpen(true);
//   };

//   // Close modal
//   const handleModalClose = () => {
//     setModalOpen(false);
//   };

//   // Example: after extension, remove or update notification
//   const handleExtensionSuccess = (newDeadline) => {
//     setNotifications((prev) =>
//       prev.filter((notif) => {
//         // Remove the notification that matches the extended order.
//         const parts = notif.id.split("-");
//         const idFromNotif = notif.orderId || parts[1];
//         return idFromNotif !== selectedOrderInfo.orderId;
//       })
//     );
//   };

//   // Filtering logic
//   const filteredNotifications = notifications.filter((notif) => {
//     if (activeTab === "all") return true;
//     if (activeTab === "unread") return !notif.isRead;
//     if (activeTab === "orders") return notif.category === "orders";
//     if (activeTab === "service") return notif.category === "service";
//     if (activeTab === "system") return notif.category === "system";
//     return true;
//   });

//   // Mark all as read
//   const markAllAsRead = () => {
//     // In a real app, call an API to mark them all as read
//     setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
//   };

//   // Switch active filter tab
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <>
//       <Navbar />

//       {/* Main container */}
//       <Container className="usernotificationpage-container">
//         {/* Page header card */}
//         <Row>
//           <Col>
//             <Card className="mb-3">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0 fw-semibold">Notifications</h5>
//                 <Button
//                   className="usernotification-btn-markallread btn-sm"
//                   onClick={markAllAsRead}
//                 >
//                   <i className="fas fa-check-double me-1"></i>
//                   Mark all as read
//                 </Button>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>

//         {/* Filter tabs/buttons */}
//         <Row>
//           <Col>
//             <div className="d-flex flex-wrap gap-2 mb-3 usernotification-filter">
//               <Button
//                 color={activeTab === "all" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("all")}
//               >
//                 All
//               </Button>
//               <Button
//                 color={activeTab === "unread" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("unread")}
//               >
//                 Unread
//               </Button>
//               <Button
//                 color={activeTab === "orders" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("orders")}
//               >
//                 Orders
//               </Button>
//               <Button
//                 color={activeTab === "service" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("service")}
//               >
//                 Services
//               </Button>
//               <Button
//                 color={activeTab === "system" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("system")}
//               >
//                 System
//               </Button>
//             </div>
//           </Col>
//         </Row>

//         {/* Notifications list */}
//         <Row>
//           <Col>
//             <Card className="usernotification-container">
//               <CardBody>
//                 {filteredNotifications.length > 0 ? (
//                   <ListGroup>
//                     {filteredNotifications.map((notif) => {
//                       // Determine icon class and wrapper color based on notif.category
//                       let iconClass = "fas fa-bell";
//                       let iconWrapperClass = "usernotification-icon-blue";
//                       if (notif.category === "orders") {
//                         iconClass = "fas fa-clipboard-check";
//                         iconWrapperClass = "usernotification-icon-blue";
//                       } else if (notif.category === "service") {
//                         iconClass = "fas fa-tools";
//                         iconWrapperClass = "usernotification-icon-green";
//                       } else if (notif.category === "system") {
//                         iconClass = "fas fa-exclamation-circle";
//                         iconWrapperClass = "usernotification-icon-red";
//                       }

//                       return (
//                         <ListGroupItem
//                           key={notif.id}
//                           className={`usernotification-item position-relative ${
//                             notif.isRead ? "" : "usernotification-unread"
//                           }`}
//                         >
//                           <div className="d-flex align-items-start">
//                             {/* Icon */}
//                             <div
//                               className={`usernotification-icon-wrapper ${iconWrapperClass} me-3`}
//                             >
//                               <i className={iconClass}></i>
//                             </div>

//                             {/* Text content */}
//                             <div className="usernotification-content flex-grow-1">
//                               <div className="usernotification-title fw-semibold mb-1">
//                                 {notif.title || "Notification Title"}
//                               </div>
//                               <div className="usernotification-message mb-1">
//                                 {notif.message}
//                               </div>
//                               <div className="usernotification-time">
//                                 {timeSince(notif.createdAt)}
//                               </div>
//                             </div>

//                             {/* Right side: optional "Extend Time" button */}
//                             <div className="ms-auto d-flex align-items-center gap-2">
//                               <Button
//                                 color="outline-secondary"
//                                 size="sm"
//                                 onClick={() => handleExtendClick(notif)}
//                               >
//                                 Extend Time
//                               </Button>

//                               {/* Ellipsis icon (like "More actions") */}
//                               <div className="usernotification-actions">
//                                 <i className="fas fa-ellipsis-v text-muted"></i>
//                               </div>
//                             </div>
//                           </div>
//                         </ListGroupItem>
//                       );
//                     })}
//                   </ListGroup>
//                 ) : (
//                   <p className="text-center mb-0">No notifications found</p>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       {/* Extend Time Modal */}
//       {modalOpen && selectedOrderInfo && (
//         <ExtendTimeModal
//           orderId={selectedOrderInfo.orderId}
//           serviceType={selectedOrderInfo.serviceType}
//           onClose={handleModalClose}
//           onExtensionSuccess={handleExtensionSuccess}
//         />
//       )}
//     </>
//   );
// };

// export default NotificationsPage;

// ******* Notification with click view and take order details ******** //

// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   ListGroup,
//   ListGroupItem,
// } from "reactstrap";
// import { jwtDecode } from "jwt-decode";
// import Navbar from "../../../Components/Navbar";
// import { URL } from "../../../config";
// import ExtendTimeModal from "../Modal/ExtendTimeModal";
// import "./notificationsPage.css";
// import { useNavigate } from "react-router-dom";

// // Helper function to convert a date into a "relative" time string.
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const NotificationsPage = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   // selectedOrderInfo now holds orderId (the order number) and serviceType.
//   const [selectedOrderInfo, setSelectedOrderInfo] = useState(null);
//   const [activeTab, setActiveTab] = useState("all");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;

//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setNotifications(data);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//   }, []);

//   // Handle "Extend Time" button for expiry notifications.
//   const handleExtendClick = (notif) => {
//     // Assume notif.id is formatted like "electrician-55" or "homeclean-55"
//     const parts = notif.id.split("-");
//     const serviceType =
//       parts[0] === "electrician"
//         ? "electrician"
//         : parts[0] === "homeclean"
//         ? "home cleaning"
//         : parts[0] === "plumber"
//         ? "plumber"
//         : "";
//     // Use notif.order_number if available; otherwise fallback to parts[1].
//     const orderNumber = notif.order_number || parts[1];
//     setSelectedOrderInfo({ orderId: orderNumber, serviceType });
//     setModalOpen(true);
//   };

//   // Handle "View" button for accepted notifications.
//   // Handle "View" button for accepted notifications.
//   const handleViewClick = (notif) => {
//     // Use the order_number provided by the backend.
//     if (notif.order_number) {
//       navigate(`/profile/orderhistory/${notif.order_number}`);
//     } else {
//       // Fallback (if not provided) using parts of notif.id:
//       const parts = notif.id.split("-");
//       const orderNumber = parts[1];
//       navigate(`/profile/orderhistory/${orderNumber}`);
//     }
//   };

//   // Close the Extend Time Modal.
//   const handleModalClose = () => {
//     setModalOpen(false);
//   };

//   // After a successful extension, remove the corresponding notification.
//   const handleExtensionSuccess = (newDeadline) => {
//     setNotifications((prev) =>
//       prev.filter((notif) => {
//         const parts = notif.id.split("-");
//         const idFromNotif = notif.orderId || parts[1];
//         return idFromNotif !== selectedOrderInfo.orderId;
//       })
//     );
//   };

//   // Filtering logic for notifications.
//   const filteredNotifications = notifications.filter((notif) => {
//     if (activeTab === "all") return true;
//     if (activeTab === "unread") return !notif.isRead;
//     if (activeTab === "orders") return notif.category === "orders";
//     if (activeTab === "service") return notif.category === "service";
//     if (activeTab === "system") return notif.category === "system";
//     return true;
//   });

//   // Mark all notifications as read.
//   const markAllAsRead = () => {
//     // In a real application, you might call an API to mark notifications as read.
//     setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
//   };

//   // Switch active filter tab.
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <>
//       <Navbar />

//       <Container className="usernotificationpage-container">
//         {/* Page Header */}
//         <Row>
//           <Col>
//             <Card className="mb-3">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0 fw-semibold">Notifications</h5>
//                 <Button
//                   className="usernotification-btn-markallread btn-sm"
//                   onClick={markAllAsRead}
//                 >
//                   <i className="fas fa-check-double me-1"></i>
//                   Mark all as read
//                 </Button>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>

//         {/* Filter Tabs */}
//         <Row>
//           <Col>
//             <div className="d-flex flex-wrap gap-2 mb-3 usernotification-filter">
//               <Button
//                 color={activeTab === "all" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("all")}
//               >
//                 All
//               </Button>
//               <Button
//                 color={activeTab === "unread" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("unread")}
//               >
//                 Unread
//               </Button>
//               <Button
//                 color={activeTab === "orders" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("orders")}
//               >
//                 Orders
//               </Button>
//               <Button
//                 color={activeTab === "service" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("service")}
//               >
//                 Services
//               </Button>
//               <Button
//                 color={activeTab === "system" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("system")}
//               >
//                 System
//               </Button>
//             </div>
//           </Col>
//         </Row>

//         {/* Notifications List */}
//         <Row>
//           <Col>
//             <Card className="usernotification-container">
//               <CardBody>
//                 {filteredNotifications.length > 0 ? (
//                   <ListGroup>
//                     {filteredNotifications.map((notif) => {
//                       // Determine if the notification is for an accepted order.
//                       const isAcceptedNotification =
//                         notif.id.includes("accepted");
//                       let iconClass = "fas fa-bell";
//                       let iconWrapperClass = "usernotification-icon-blue";
//                       if (notif.category === "orders") {
//                         iconClass = "fas fa-clipboard-check";
//                         iconWrapperClass = "usernotification-icon-blue";
//                       } else if (notif.category === "service") {
//                         iconClass = "fas fa-tools";
//                         iconWrapperClass = "usernotification-icon-green";
//                       } else if (notif.category === "system") {
//                         iconClass = "fas fa-exclamation-circle";
//                         iconWrapperClass = "usernotification-icon-red";
//                       }

//                       return (
//                         <ListGroupItem
//                           key={notif.id}
//                           className={`usernotification-item position-relative ${
//                             notif.isRead ? "" : "usernotification-unread"
//                           }`}
//                         >
//                           <div className="d-flex align-items-start">
//                             {/* Notification Icon */}
//                             <div
//                               className={`usernotification-icon-wrapper ${iconWrapperClass} me-3`}
//                             >
//                               <i className={iconClass}></i>
//                             </div>

//                             {/* Notification Content */}
//                             <div className="usernotification-content flex-grow-1">
//                               <div className="usernotification-title fw-semibold mb-1">
//                                 {notif.title || "Notification Title"}
//                               </div>
//                               <div className="usernotification-message mb-1">
//                                 {notif.message}
//                               </div>
//                               <div className="usernotification-time">
//                                 {timeSince(notif.createdAt)}
//                               </div>
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="ms-auto d-flex align-items-center gap-2">
//                               {isAcceptedNotification ? (
//                                 <Button
//                                   color="outline-secondary"
//                                   size="sm"
//                                   onClick={() => handleViewClick(notif)}
//                                 >
//                                   View
//                                 </Button>
//                               ) : (
//                                 <Button
//                                   color="outline-secondary"
//                                   size="sm"
//                                   onClick={() => handleExtendClick(notif)}
//                                 >
//                                   Extend Time
//                                 </Button>
//                               )}
//                               <div className="usernotification-actions">
//                                 <i className="fas fa-ellipsis-v text-muted"></i>
//                               </div>
//                             </div>
//                           </div>
//                         </ListGroupItem>
//                       );
//                     })}
//                   </ListGroup>
//                 ) : (
//                   <p className="text-center mb-0">No notifications found</p>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       {/* Extend Time Modal */}
//       {modalOpen && selectedOrderInfo && (
//         <ExtendTimeModal
//           orderId={selectedOrderInfo.orderId}
//           serviceType={selectedOrderInfo.serviceType}
//           onClose={handleModalClose}
//           onExtensionSuccess={handleExtensionSuccess}
//         />
//       )}
//     </>
//   );
// };

// export default NotificationsPage;

// // Update with marks as read api

// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   ListGroup,
//   ListGroupItem,
// } from "reactstrap";
// import { jwtDecode } from "jwt-decode";
// import Navbar from "../../../Components/Navbar";
// import { URL } from "../../../config";
// import ExtendTimeModal from "../Modal/ExtendTimeModal";
// import "./notificationsPage.css";
// import { useNavigate } from "react-router-dom";

// // Helper function to convert a date into a "relative" time string.
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const NotificationsPage = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   // selectedOrderInfo now holds orderId (the order number) and serviceType.
//   const [selectedOrderInfo, setSelectedOrderInfo] = useState(null);
//   const [activeTab, setActiveTab] = useState("all");
//   const navigate = useNavigate();

//   // Fetch notifications for the user
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setNotifications(data);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//     // Optionally, you can set up a timer to refresh notifications every minute:
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, []);

//   // Function to mark a notification as read
//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const response = await fetch(`${URL}/notifications/${notificationId}/read`, {
//         method: "PATCH",
//       });
//       if (response.ok) {
//         // Update the notification in local state
//         setNotifications((prev) =>
//           prev.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Helper to render the appropriate action button based on notification type.
//     const renderActionButton = (notif) => {
//       if (notif.type === "deadline_warning_pending") {
//         // This temporary warning notification prompts the user to extend the time.
//         return (
//           <Button
//             color="outline-secondary"
//             size="sm"
//             onClick={() => handleExtendClick(notif)}
//           >
//             Extend Time
//           </Button>
//         );
//       } else if (
//         notif.type === "order_accepted" ||
//         notif.type === "order_in_progress" ||
//         notif.type === "order_completed"
//       ) {
//         // For these types, the user should view order details.
//         return (
//           <Button
//             color="outline-secondary"
//             size="sm"
//             onClick={() => handleViewClick(notif)}
//           >
//             View
//           </Button>
//         );
//       } else if (
//         notif.type === "order_cancelled" ||
//         notif.type === "penalty_applied"
//       ) {
//         // For cancelled or penalty notifications, no action button is necessary.
//         return null;
//       } else {
//         // Fallback action: show a "View" button.
//         return (
//           <Button
//             color="outline-secondary"
//             size="sm"
//             onClick={() => handleViewClick(notif)}
//           >
//             View
//           </Button>
//         );
//       }
//     };

//   const handleExtendClick = (notif) => {
//     // Determine service type based on order number prefix.
//     let serviceType = "";
//     if (notif.orderNumber.startsWith("PS-")) {
//       serviceType = "plumber";
//     } else if (notif.orderNumber.startsWith("ES-")) {
//       serviceType = "electrician";
//     } else if (notif.orderNumber.startsWith("HS-")) {
//       serviceType = "home cleaning";
//     }

//     if (!serviceType) {
//       alert("Unable to determine service type for this order.");
//       return;
//     }

//     setSelectedOrderInfo({ orderId: notif.orderNumber, serviceType });
//     setModalOpen(true);
//   };

//   // Handle "View" button for accepted notifications.
//   const handleViewClick = (notif) => {
//     if (notif.orderNumber) {
//       navigate(`/profile/orderhistory/${notif.orderNumber}`);
//     } else {
//       // Fallback if orderNumber is missing
//       navigate(`/profile/orderhistory/`);
//     }
//   };

//   // Close the Extend Time Modal.
//   const handleModalClose = () => {
//     setModalOpen(false);
//   };

//   // After a successful extension, remove the corresponding notification.
//   const handleExtensionSuccess = (newDeadline) => {
//     setNotifications((prev) =>
//       prev.filter((notif) => notif.orderNumber !== selectedOrderInfo.orderId)
//     );
//   };

//   // Filtering logic for notifications.
//   const filteredNotifications = notifications.filter((notif) => {
//     if (activeTab === "all") return true;
//     if (activeTab === "unread") return !notif.isRead;
//     // Assuming you have a field "category" on your notification, otherwise use "type"
//     if (activeTab === "orders") return notif.type === "order_accepted" || notif.type === "order_cancelled";
//     if (activeTab === "service") return notif.type === "service_update";
//     if (activeTab === "system") return notif.type === "system";
//     return true;
//   });

//   // Mark all notifications as read.
//   const markAllAsRead = async () => {
//     // Loop through notifications and mark as read via API
//     for (let notif of notifications) {
//       if (!notif.isRead) {
//         await markNotificationAsRead(notif.Id);
//       }
//     }
//   };

//   // Switch active filter tab.
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <>
//       <Navbar />
//       <Container className="usernotificationpage-container">
//         {/* Page Header */}
//         <Row>
//           <Col>
//             <Card className="mb-3">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0 fw-semibold">Notifications</h5>
//                 <Button
//                   className="usernotification-btn-markallread btn-sm"
//                   onClick={markAllAsRead}
//                 >
//                   <i className="fas fa-check-double me-1"></i>
//                   Mark all as read
//                 </Button>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//         {/* Filter Tabs */}
//         <Row>
//           <Col>
//             <div className="d-flex flex-wrap gap-2 mb-3 usernotification-filter">
//               <Button
//                 color={activeTab === "all" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("all")}
//               >
//                 All
//               </Button>
//               <Button
//                 color={activeTab === "unread" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("unread")}
//               >
//                 Unread
//               </Button>
//               <Button
//                 color={activeTab === "orders" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("orders")}
//               >
//                 Orders
//               </Button>
//               <Button
//                 color={activeTab === "service" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("service")}
//               >
//                 Services
//               </Button>
//               <Button
//                 color={activeTab === "system" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("system")}
//               >
//                 System
//               </Button>
//             </div>
//           </Col>
//         </Row>
//         {/* Notifications List */}
//         <Row>
//           <Col>
//             <Card className="usernotification-container">
//               <CardBody>
//                 {filteredNotifications.length > 0 ? (
//                   <ListGroup>
//                     {filteredNotifications.map((notif) => (
//                       <ListGroupItem
//                         key={notif.Id}
//                         className={`usernotification-item position-relative ${notif.isRead ? "" : "usernotification-unread"}`}
//                         onClick={() => markNotificationAsRead(notif.Id)}
//                       >
//                         <div className="d-flex align-items-start">
//                           {/* Notification Icon */}
//                           <div className="usernotification-icon-wrapper me-3">
//                             <i className="fas fa-bell"></i>
//                           </div>
//                           {/* Notification Content */}
//                           <div className="usernotification-content flex-grow-1">
//                             <div className="usernotification-title fw-semibold mb-1">
//                               {notif.title || "Notification Title"}
//                             </div>
//                             <div className="usernotification-message mb-1">
//                               {notif.message}
//                             </div>
//                             <div className="usernotification-time">
//                               {timeSince(notif.created_at)}
//                             </div>
//                           </div>
//                           {/* Action Buttons */}
//                           <div className="ms-auto d-flex align-items-center gap-2">
//                             {/* {notif.type === "order_accepted" ? (
//                               <Button
//                                 color="outline-secondary"
//                                 size="sm"
//                                 onClick={() => handleViewClick(notif)}
//                               >
//                                 View
//                               </Button>
//                             ) : (
//                               <Button
//                                 color="outline-secondary"
//                                 size="sm"
//                                 onClick={() => handleExtendClick(notif)}
//                               >
//                                 Extend Time
//                               </Button>
//                             )} */}
//                             {renderActionButton(notif)}
//                           </div>
//                         </div>
//                       </ListGroupItem>
//                     ))}
//                   </ListGroup>
//                 ) : (
//                   <p className="text-center mb-0">No notifications found</p>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//       {/* Extend Time Modal */}
//       {modalOpen && selectedOrderInfo && (
//         <ExtendTimeModal
//           orderId={selectedOrderInfo.orderId}
//           serviceType={selectedOrderInfo.serviceType}
//           onClose={handleModalClose}
//           onExtensionSuccess={handleExtensionSuccess}
//         />
//       )}
//     </>
//   );
// };

// export default NotificationsPage;

// ***** All checked, working okay (24-6-25) ***** //
// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   ListGroup,
//   ListGroupItem,
// } from "reactstrap";
// import { jwtDecode } from "jwt-decode";
// import Navbar from "../../../Components/Navbar";
// import { URL } from "../../../config";
// import ExtendTimeModal from "../Modal/ExtendTimeModal";
// import "./notificationsPage.css";
// import { useNavigate } from "react-router-dom";

// // Helper function to convert a date into a "relative" time string.
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// // Helper function to select icon and display title based on notification type.
// // const getNotificationIconAndTitle = (notif) => {
// //   switch (notif.type) {
// //     case "deadline_warning_pending":
// //       return { iconClass: "fas fa-exclamation-triangle", displayTitle: "Deadline Warning" };
// //     case "order_accepted":
// //       return { iconClass: "fas fa-check-circle", displayTitle: "Order Accepted" };
// //     case "order_in_progress":
// //       return { iconClass: "fas fa-spinner", displayTitle: "Order In Progress" };
// //     case "order_completed":
// //       return { iconClass: "fas fa-check", displayTitle: "Order Completed" };
// //     case "order_cancelled":
// //       return { iconClass: "fas fa-times-circle text-danger", displayTitle: "Order Cancelled" };
// //     case "penalty_applied":
// //       return { iconClass: "fas fa-exclamation-circle", displayTitle: "Penalty Applied" };
// //     case "deadline_extended":
// //       return { iconClass: "fas fa-clock", displayTitle: "Deadline Extended" };
// //     default:
// //       return { iconClass: "fas fa-info-circle", displayTitle: "Notification" };
// //   }
// // };

// // Example with color-coded backgrounds for each type:
// const getNotificationIconAndTitle = (notif) => {
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       return {
//         iconClass: "fas fa-exclamation-triangle",
//         displayTitle: "Deadline Warning",
//         iconBgClass: "usernotification-icon-warning",
//       };
//     case "order_accepted":
//       return {
//         iconClass: "fas fa-check-circle",
//         displayTitle: "Order Accepted",
//         iconBgClass: "usernotification-icon-green",
//       };
//     case "order_in_progress":
//       // Add a spinner effect with 'fa-spin'
//       return {
//         iconClass: "fas fa-spinner fa-spin",
//         displayTitle: "Order In Progress",
//         iconBgClass: "usernotification-icon-blue",
//       };
//     case "order_completed":
//       return {
//         iconClass: "fas fa-check",
//         displayTitle: "Order Completed",
//         iconBgClass: "usernotification-icon-green",
//       };
//     case "order_cancelled":
//       return {
//         iconClass: "fas fa-times-circle",
//         displayTitle: "Order Cancelled",
//         iconBgClass: "usernotification-icon-red",
//       };
//     case "penalty_applied":
//       return {
//         iconClass: "fas fa-exclamation-circle",
//         displayTitle: "Penalty Applied",
//         iconBgClass: "usernotification-icon-red",
//       };
//     case "deadline_extended":
//       return {
//         iconClass: "fas fa-clock",
//         displayTitle: "Deadline Extended",
//         iconBgClass: "usernotification-icon-purple",
//       };
//     default:
//       return {
//         iconClass: "fas fa-info-circle",
//         displayTitle: "Notification",
//         iconBgClass: "usernotification-icon-default",
//       };
//   }
// };

// const NotificationsPage = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   // selectedOrderInfo now holds orderId (the order number) and serviceType.
//   const [selectedOrderInfo, setSelectedOrderInfo] = useState(null);
//   const [activeTab, setActiveTab] = useState("all");
//   const navigate = useNavigate();

//   // Fetch notifications for the user
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setNotifications(data);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//     // Optionally, you can set up a timer to refresh notifications every minute:
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, []);

//   // Function to mark a notification as read
//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const response = await fetch(`${URL}/notifications/${notificationId}/read`, {
//         method: "PATCH",
//       });
//       if (response.ok) {
//         // Update the notification in local state
//         setNotifications((prev) =>
//           prev.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Helper to render the appropriate action button based on notification type.
//   const renderActionButton = (notif) => {
//     if (notif.type === "deadline_warning_pending") {
//       return (
//         <Button
//           className="usernotification-extend-btn"
//           size="sm"
//           onClick={() => handleExtendClick(notif)}
//         >
//           Extend Time
//         </Button>
//       );
//     } else if (
//       notif.type === "order_accepted" ||
//       notif.type === "order_in_progress" ||
//       notif.type === "order_completed"
//     ) {
//       return (
//         <Button
//           className="usernotification-view-btn"
//           size="sm"
//           onClick={() => handleViewClick(notif)}
//         >
//           View
//         </Button>
//       );
//     } else if (
//       notif.type === "order_cancelled" ||
//       notif.type === "penalty_applied"
//     ) {
//       return null;
//     } else {
//       return (
//         <Button
//           className="usernotification-view-btn"
//           size="sm"
//           onClick={() => handleViewClick(notif)}
//         >
//           View
//         </Button>
//       );
//     }
//   };

//   const handleExtendClick = (notif) => {
//     let serviceType = "";
//     if (notif.orderNumber.startsWith("PS-")) {
//       serviceType = "plumber";
//     } else if (notif.orderNumber.startsWith("ES-")) {
//       serviceType = "electrician";
//     } else if (notif.orderNumber.startsWith("HS-")) {
//       serviceType = "home cleaning";
//     }

//     if (!serviceType) {
//       alert("Unable to determine service type for this order.");
//       return;
//     }

//     setSelectedOrderInfo({ orderId: notif.orderNumber, serviceType });
//     setModalOpen(true);
//   };

//   const handleViewClick = (notif) => {
//     if (notif.orderNumber) {
//       navigate(`/profile/orderhistory/${notif.orderNumber}`);
//     } else {
//       navigate(`/profile/orderhistory/`);
//     }
//   };

//   const handleModalClose = () => {
//     setModalOpen(false);
//   };

//   const handleExtensionSuccess = (newDeadline) => {
//     setNotifications((prev) =>
//       prev.filter((notif) => notif.orderNumber !== selectedOrderInfo.orderId)
//     );
//   };

//   const filteredNotifications = notifications.filter((notif) => {
//     if (activeTab === "all") return true;
//     if (activeTab === "unread") return !notif.isRead;
//     if (activeTab === "orders") return notif.type === "order_accepted" || notif.type === "order_cancelled";
//     if (activeTab === "service") return notif.type === "service_update";
//     if (activeTab === "system") return notif.type === "system";
//     return true;
//   });

//   const markAllAsRead = async () => {
//     for (let notif of notifications) {
//       if (!notif.isRead) {
//         await markNotificationAsRead(notif.Id);
//       }
//     }
//   };

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <>
//       <Navbar />
//       <Container className="usernotificationpage-container">
//         {/* Page Header */}
//         <Row>
//           <Col>
//             <Card className="mb-3">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0 fw-semibold">Notifications</h5>
//                 <Button
//                   className="usernotification-btn-markallread btn-sm"
//                   onClick={markAllAsRead}
//                 >
//                   <i className="fas fa-check-double me-1"></i>
//                   Mark all as read
//                 </Button>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//         {/* Filter Tabs */}
//         <Row>
//           <Col>
//             <div className="d-flex flex-wrap gap-2 mb-3 usernotification-filter">
//               <Button
//                 color={activeTab === "all" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("all")}
//               >
//                 All
//               </Button>
//               <Button
//                 color={activeTab === "unread" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("unread")}
//               >
//                 Unread
//               </Button>
//               <Button
//                 color={activeTab === "orders" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("orders")}
//               >
//                 Orders
//               </Button>
//               <Button
//                 color={activeTab === "service" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("service")}
//               >
//                 Services
//               </Button>
//               <Button
//                 color={activeTab === "system" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("system")}
//               >
//                 System
//               </Button>
//             </div>
//           </Col>
//         </Row>
//         {/* Notifications List */}
//         <Row>
//           <Col>
//             <Card className="usernotification-container">
//               <CardBody>
//                 {filteredNotifications.length > 0 ? (
//                   <ListGroup>
//                     {filteredNotifications.map((notif) => {
//                       const { iconClass, displayTitle, iconBgClass } = getNotificationIconAndTitle(notif);

//                       return (
//                         <ListGroupItem
//                           key={notif.Id}
//                           className={`usernotification-item position-relative ${
//                             notif.isRead ? "" : "usernotification-unread"
//                           }`}
//                           onClick={() => markNotificationAsRead(notif.Id)}
//                         >
//                           <div className="d-flex justify-content-between align-items-start w-100">
//                             {/* Left side: icon + text */}
//                             <div className="d-flex align-items-start">
//                               {/* Notice we apply iconBgClass here */}
//                               <div className={`usernotification-icon-wrapper ${iconBgClass} me-2`}>
//                                 <i className={iconClass}></i>
//                               </div>
//                               <div className="usernotification-content">
//                                 <div className="usernotification-title fw-semibold">
//                                   {displayTitle}
//                                 </div>
//                                 <div className="usernotification-message">
//                                   {notif.message}
//                                 </div>
//                                 <div className="usernotification-time">
//                                   {timeSince(notif.created_at)}
//                                 </div>
//                               </div>
//                             </div>

//                             {/* Right side: action buttons */}
//                             <div className="d-flex align-items-center gap-2">
//                               {renderActionButton(notif)}
//                             </div>
//                           </div>
//                         </ListGroupItem>
//                       );
//                     })}
//                   </ListGroup>
//                 ) : (
//                   <p className="text-center mb-0">No notifications found</p>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//       {/* Extend Time Modal */}
//       {modalOpen && selectedOrderInfo && (
//         <ExtendTimeModal
//           orderId={selectedOrderInfo.orderId}
//           serviceType={selectedOrderInfo.serviceType}
//           onClose={handleModalClose}
//           onExtensionSuccess={handleExtensionSuccess}
//         />
//       )}
//     </>
//   );
// };

// export default NotificationsPage;

// ***** Upper code is okay (24-6-25) ***** //

// ***** Added Trasnlate EN BN (24-6-25) ***** //
// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   ListGroup,
//   ListGroupItem,
// } from "reactstrap";
// import { jwtDecode } from "jwt-decode";
// import Navbar from "../../../Components/Navbar";
// import { URL } from "../../../config";
// import ExtendTimeModal from "../Modal/ExtendTimeModal";
// import "./notificationsPage.css";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import Loader from "../../../Components/LoaderSpin/Loader";

// // Helper function to convert a date into a "relative" time string.
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// // Helper function to select icon, display title, and message key based on notification type.
// const getNotificationIconAndTitle = (notif, t) => {
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       return {
//         iconClass: "fas fa-exclamation-triangle",
//         // displayTitle: "Deadline Warning",
//         displayTitle: t("notifications.deadline_warning"),
//         messageKey: "notifications.messages.deadline_warning_pending",
//         messageParams: { orderNumber: notif.orderNumber },
//         iconBgClass: "usernotification-icon-warning",
//       };
//     case "order_accepted":
//       return {
//         iconClass: "fas fa-check-circle",
//         // displayTitle: "Order Accepted",
//         displayTitle: t("notifications.order_accepted"),
//         messageKey: "notifications.messages.order_accepted",
//         messageParams: { orderNumber: notif.orderNumber },
//         iconBgClass: "usernotification-icon-green",
//       };
//     case "order_in_progress":
//       return {
//         iconClass: "fas fa-spinner fa-spin",
//         // displayTitle: "Order In Progress",
//         displayTitle: t("notifications.order_in_progress"),
//         messageKey:
//           notif.recipientType === "user"
//             ? "notifications.messages.order_in_progress_user"
//             : "notifications.messages.order_in_progress_servitor",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           // fetched servitor names
//           servitorFirstName: notif.servitorFirstName || "Unknown",
//           servitorLastName: notif.servitorLastName || "",
//         },
//         iconBgClass: "usernotification-icon-blue",
//       };
//     case "order_completed":
//       return {
//         iconClass: "fas fa-check",
//         // displayTitle: "Order Completed",
//         displayTitle: t("notifications.order_completed"),
//         messageKey:
//           notif.recipientType === "user"
//             ? "notifications.messages.order_completed_user"
//             : "notifications.messages.order_completed_servitor",
//         messageParams: { orderNumber: notif.orderNumber },
//         iconBgClass: "usernotification-icon-green",
//       };
//     case "order_cancelled":
//       return {
//         iconClass: "fas fa-times-circle",
//         // displayTitle: "Order Cancelled",
//         displayTitle: t("notifications.order_cancelled"),
//         messageKey: notif.message.includes("no servitor acceptance")
//           ? "notifications.messages.order_cancelled_timeout"
//           : notif.message.includes("cancelled by the servitor")
//           ? "notifications.messages.order_cancelled_by_servitor"
//           : notif.message.includes("cancelled by the user")
//           ? "notifications.messages.order_cancelled_by_user"
//           : "notifications.messages.order_cancelled_missed_deadline",
//         messageParams: { orderNumber: notif.orderNumber },
//         iconBgClass: "usernotification-icon-red",
//       };
//     case "penalty_applied":
//       return {
//         iconClass: "fas fa-exclamation-circle",
//         // displayTitle: "Penalty Applied",
//         displayTitle: t("notifications.penalty_applied"),
//         messageKey: "notifications.messages.penalty_applied",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           penaltyAmount: notif.penaltyAmount || 40, // Default from backend
//         },
//         iconBgClass: "usernotification-icon-red",
//       };
//     case "deadline_extended":
//       return {
//         iconClass: "fas fa-clock",
//         // displayTitle: "Deadline Extended",
//         displayTitle: t("notifications.deadline_extended"),
//         messageKey: "notifications.messages.deadline_extended",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           // newDeadline: notif.newDeadline
//           //   ? new Date(notif.newDeadline).toLocaleString()
//           //   : "unknown",
//           newDeadline: notif.newDeadline || t("notifications.unknown"),
//         },
//         iconBgClass: "usernotification-icon-purple",
//       };
//     case "account_blocked":
//       return {
//         iconClass: "fas fa-ban",
//         // displayTitle: "Account Blocked",
//         displayTitle: t("notifications.account_blocked"),
//         messageKey: "notifications.messages.account_blocked",
//         messageParams: {
//           penaltyCount: notif.penaltyCount || 3, // Default from backend
//           penaltyAmount: notif.penaltyAmount || 90, // Default based on 30 * penaltyCount
//         },
//         iconBgClass: "usernotification-icon-red",
//       };
//     case "order_cancelled_with_penalty":
//       return {
//         iconClass: "fas fa-times-circle",
//         // displayTitle: "Order Cancelled with Penalty",
//         displayTitle: t("notifications.order_cancelled_with_penalty"),
//         messageKey: "notifications.messages.order_cancelled_with_penalty",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           penaltyAmount: notif.penaltyAmount || 30, // Default from backend
//           penaltyCount: notif.penaltyCount || 1,
//         },
//         iconBgClass: "usernotification-icon-red",
//       };
//     case "order_updated":
//       return {
//         iconClass: "fas fa-sync-alt",
//         displayTitle: t("notifications.order_updated"),
//         messageKey: "notifications.messages.order_updated",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           priceDelta: notif.priceDelta,
//           newTotal: notif.newTotal,
//           minutesAdded: notif.minutesAdded,
//           newDeadline: notif.newDeadline ? notif.newDeadline : undefined,
//         },
//         iconBgClass: "usernotification-icon-blue",
//       };

//       case "order_rescheduled": {
//       // Try to extract the new schedule from the backend message, e.g.
//       // "rescheduled to 2025-02-20 3:30 PM." or "(new deadline: ...)"
//       const m1 = notif.message?.match(/rescheduled to\s*(.+?)\.?$/i);
//       const m2 = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
//       const m3 = notif.message?.match(/\(new deadline:\s*(.+?)\)/i);
//       const newSchedule = (m1 && m1[1]) || (m2 && m2[1]) || (m3 && m3[1]) || t("notifications.unknown");
//       return {
//         iconClass: "fas fa-clock",
//         displayTitle: t("notifications.order_rescheduled"),
//         messageKey: "notifications.messages.order_rescheduled",
//         messageParams: { orderNumber: notif.orderNumber, newSchedule },
//         iconBgClass: "usernotification-icon-purple",
//       };
//     }
//     case "order_reordered": {
//       // Extract "New schedule: ..." from the message
//       const m = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
//       const newSchedule = (m && m[1]) || t("notifications.unknown");
//       return {
//         iconClass: "fas fa-sync-alt",
//         displayTitle: t("notifications.order_reordered"),
//         messageKey: "notifications.messages.order_reordered",
//         messageParams: { orderNumber: notif.orderNumber, newSchedule },
//         iconBgClass: "usernotification-icon-blue",
//       };
//     }

//     case "tutor_accepted":
//       return {
//         iconClass: "fas fa-user-check",
//         displayTitle: t("notifications.tutor_accepted"),
//         messageKey: "notifications.messages.tutor_accepted",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           servitorFirstName:
//             notif.servitorFirstName || t("notifications.unknown"),
//           servitorLastName: notif.servitorLastName || "",
//         },
//         iconBgClass: "usernotification-icon-blue",
//       };
//     case "tutor_user_approved":
//       return {
//         iconClass: "fas fa-user-check", // fallback font-awesome alt: "fas fa-check-circle"
//         displayTitle: t("notifications.tutor_user_approved"),
//         messageKey: "notifications.messages.tutor_user_approved",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           servitorFirstName:
//             notif.servitorFirstName || t("notifications.unknown"),
//           servitorLastName: notif.servitorLastName || "",
//         },
//         iconBgClass: "usernotification-icon-green",
//       };
//     case "tutor_hired":
//       return {
//         iconClass: "fas fa-user-tie",
//         displayTitle: t("notifications.tutor_hired"),
//         messageKey: "notifications.messages.tutor_hired",
//         messageParams: {
//           orderNumber: notif.orderNumber,
//           servitorFirstName:
//             notif.servitorFirstName || t("notifications.unknown"),
//           servitorLastName: notif.servitorLastName || "",
//         },
//         iconBgClass: "usernotification-icon-purple",
//       };

//       case "reward_points_awarded":
//       return {
//         iconClass: "fas fa-trophy",
//         displayTitle: t("notifications.reward_points_awarded"), // "Reward Points"
//         // Use different message keys for user vs servitor (optional, but nicer)
//         messageKey:
//           notif.recipientType === "servitor"
//             ? "notifications.messages.reward_points_awarded_servitor"
//             : "notifications.messages.reward_points_awarded_user",
//         messageParams: {
//           orderNumber: notif.orderNumber || t("notifications.unknown"),
//           points: notif.rewardPoints, // parsed; will fallback to defaultValue
//         },
//         iconBgClass: "usernotification-icon-blue",
//       };

//     case "reward_claimed":
//       return {
//         iconClass: "fas fa-wallet",
//         displayTitle: t("notifications.reward_claimed"), // "Reward Claimed"
//         messageKey: "notifications.messages.reward_claimed",
//         messageParams: {
//           claimAmount: notif.claimAmount,                 // parsed
//           claimReference: notif.claimRef || t("notifications.unknown"), // RW-... if present
//         },
//         iconBgClass: "usernotification-icon-green",
//       };


//     default:
//       return {
//         iconClass: "fas fa-info-circle",
//         // displayTitle: "Notification",
//         displayTitle: t("notifications.notification_default"),
//         messageKey:
//           notif.type === "service_update"
//             ? "notifications.messages.service_update"
//             : notif.type === "system"
//             ? "notifications.messages.system"
//             : "notifications.messages.notification_default",
//         messageParams: { orderNumber: notif.orderNumber || "" },
//         iconBgClass: "usernotification-icon-default",
//       };
//   }
// };

// const NotificationsPage = () => {
//   const { t } = useTranslation();

//   const [notifications, setNotifications] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   // selectedOrderInfo now holds orderId (the order number) and serviceType.
//   const [selectedOrderInfo, setSelectedOrderInfo] = useState(null);
//   const [activeTab, setActiveTab] = useState("all");
//   const navigate = useNavigate();

//   // Fetch notifications for the user
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             // setNotifications(data);

//             // New added for Traslate
//             // Enhance notifications with parsed dynamic fields if needed
//             const enhancedNotifications = await Promise.all(
//               data.map(async (notif) => {
//                 let penaltyAmount,
//                   penaltyCount,
//                   newDeadline,
//                   servitorFirstName,
//                   servitorLastName,
//                   newTotal,
//                   priceDelta,
//                   minutesAdded,
//                   rewardPoints,
//                   claimAmount,
//                   claimRef;
//                 // Parse dynamic fields
//                 if (notif.type === "penalty_applied") {
//                   const match = notif.message.match(/A penalty of (\d+) taka/);
//                   penaltyAmount = match ? parseInt(match[1]) : 40;
//                 } else if (notif.type === "order_cancelled_with_penalty") {
//                   const penaltyMatch = notif.message.match(
//                     /Total penalty: (\d+) taka/
//                   );
//                   const countMatch = notif.message.match(
//                     /Cancellation count: (\d+)/
//                   );
//                   penaltyAmount = penaltyMatch ? parseInt(penaltyMatch[1]) : 30;
//                   penaltyCount = countMatch ? parseInt(countMatch[1]) : 1;
//                 } else if (notif.type === "account_blocked") {
//                   const penaltyMatch = notif.message.match(
//                     /Total penalty: (\d+) taka/
//                   );
//                   const countMatch = notif.message.match(/\((\d+) times\)/);
//                   penaltyAmount = penaltyMatch ? parseInt(penaltyMatch[1]) : 90;
//                   penaltyCount = countMatch ? parseInt(countMatch[1]) : 3;
//                 } else if (notif.type === "deadline_extended") {
//                   const match = notif.message.match(/extended to (.+)\./);
//                   newDeadline = match ? match[1] : null;
//                 } else if (
//                   notif.type === "order_in_progress" &&
//                   notif.recipientType === "user"
//                 ) {
//                   // ADDED: Fetch servitor details if servitorId is provided
//                   if (notif.servitorId) {
//                     try {
//                       const servitorResponse = await fetch(
//                         `${URL}/servitors/${
//                           notif.servitorId.split("servitor-")[1]
//                         }`
//                       );
//                       if (servitorResponse.ok) {
//                         const servitorData = await servitorResponse.json();
//                         servitorFirstName = servitorData.FirstName || "Unknown";
//                         servitorLastName = servitorData.LastName || "";
//                       } else {
//                         // NEW CHANGE: Fallback to parsing message with updated regex
//                         const match = notif.message.match(
//                           /accepted by ([^\s]+)\s*([^\s]*)/
//                         );
//                         servitorFirstName = match ? match[1] : "Unknown";
//                         servitorLastName = match ? match[2] : "";
//                       }
//                     } catch (error) {
//                       console.error("Error fetching servitor:", error);
//                       // NEW CHANGE: Fallback to parsing message with updated regex
//                       const match = notif.message.match(
//                         /accepted by ([^\s]+)\s*([^\s]*)/
//                       );
//                       servitorFirstName = match ? match[1] : "Unknown";
//                       servitorLastName = match ? match[2] : "";
//                     }
//                   } else if (
//                     [
//                       "tutor_accepted",
//                       "tutor_user_approved",
//                       "tutor_hired",
//                     ].includes(notif.type) &&
//                     notif.recipientType === "user"
//                   ) {
//                     const rawServitorId = notif.servitorId || notif.servitor_id;
//                     if (rawServitorId) {
//                       try {
//                         const cleanId = String(rawServitorId).includes(
//                           "servitor-"
//                         )
//                           ? rawServitorId.split("servitor-")[1]
//                           : rawServitorId;
//                         const servitorResponse = await fetch(
//                           `${URL}/servitors/${cleanId}`
//                         );
//                         if (servitorResponse.ok) {
//                           const s = await servitorResponse.json();
//                           servitorFirstName = s.FirstName || "Unknown";
//                           servitorLastName = s.LastName || "";
//                         }
//                       } catch {}
//                     }
//                   } else if (notif.type === "order_updated") {
//                     // CHANGE: Updated regex patterns to be more permissive and added debugging logs
//                     console.log("Raw order_updated message:", notif.message);
//                     const deltaMatch = notif.message?.match(
//                       /(?:increased|updated) by\s*(\d+)\s*tk/i
//                     );
//                     const totalMatch = notif.message?.match(
//                       /(?:New total price|New total)\s*(\d+)\s*tk/i
//                     );
//                     const minutesMatch = notif.message?.match(
//                       /extended by\s*(\d+)\s*minute?s?/i
//                     );
//                     const toMatch = notif.message?.match(
//                       /new deadline:\s*(.*?)(?:\)|$)/i
//                     );
//                     priceDelta = deltaMatch
//                       ? parseInt(deltaMatch[1], 10)
//                       : undefined;
//                     newTotal = totalMatch
//                       ? parseInt(totalMatch[1], 10)
//                       : undefined;
//                     minutesAdded = minutesMatch
//                       ? parseInt(minutesMatch[1], 10)
//                       : undefined;
//                     newDeadline = toMatch ? toMatch[1] : undefined;
//                     console.log("Parsed values:", {
//                       priceDelta,
//                       newTotal,
//                       minutesAdded,
//                       newDeadline,
//                     });
//                   } // 🔧 NEW — parse reward points awarded
//                 if (notif.type === "reward_points_awarded") {
//                   // Prefer backend-provided value if present:
//                   if (typeof notif.rewardPoints === "number") {
//                     rewardPoints = notif.rewardPoints;
//                   } else {
//                     // fallback: parse from message
//                     // examples: "You earned 5 reward points ..." or "You earned 5 points ..."
//                     const m = notif.message?.match(/earned\s+(\d+)\s+(?:reward\s+)?points?/i);
//                     rewardPoints = m ? parseInt(m[1], 10) : undefined;
//                   }
//                 }

//                 // 🔧 NEW — parse reward claimed (amount + optional reference)
//                 if (notif.type === "reward_claimed") {
//                   // Prefer backend-provided values if present:
//                   if (typeof notif.claimAmount === "number") {
//                     claimAmount = notif.claimAmount;
//                   } else {
//                     // message example: "Reward claimed: 120 tk added to your balance."
//                     const m = notif.message?.match(/claimed:\s*(\d+)\s*tk/i);
//                     claimAmount = m ? parseInt(m[1], 10) : undefined;
//                   }

//                   if (notif.claimRef) {
//                     claimRef = notif.claimRef;
//                   } else {
//                     // message may include "Ref: RW-8-20250930044401283"
//                     // const r = notif.message?.match(/Ref:\s*([A-Z0-9\-]+)/i);
//                     const r = notif.message?.match(/Ref:\s*([A-Z0-9-]+)/i);
//                     claimRef = r ? r[1] : undefined;
//                   }
//                 } else {
//                     // NEW CHANGE: Fallback to parsing message with updated regex if no servitorId
//                     const match = notif.message.match(
//                       /accepted by ([^\s]+)\s*([^\s]*)/
//                     );
//                     servitorFirstName = match ? match[1] : "Unknown";
//                     servitorLastName = match ? match[2] : "";
//                   }
//                 }
//                 return {
//                   ...notif,
//                   penaltyAmount,
//                   penaltyCount,
//                   newDeadline,
//                   servitorFirstName,
//                   servitorLastName,
//                   priceDelta,
//                   newTotal,
//                   minutesAdded,

//                   rewardPoints,
//                   claimAmount,
//                   claimRef,
//                 };
//               })
//             );
//             setNotifications(enhancedNotifications);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNotifications();
//     // Optionally, you can set up a timer to refresh notifications every minute:
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, []);

//   // Function to mark a notification as read
//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const response = await fetch(
//         `${URL}/notifications/${notificationId}/read`,
//         {
//           method: "PATCH",
//         }
//       );
//       if (response.ok) {
//         // Update the notification in local state
//         setNotifications((prev) =>
//           prev.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Helper to render the appropriate action button based on notification type.
//   const renderActionButton = (notif) => {
//     if (notif.type === "deadline_warning_pending") {
//       return (
//         <Button
//           className="usernotification-extend-btn"
//           size="sm"
//           onClick={() => handleExtendClick(notif)}
//         >
//           {/* Extend Time */}
//           {t("notifications.extend_time")}
//         </Button>
//       );
//     } else if (
//       [
//         "order_accepted",
//         "order_in_progress",
//         "order_completed",
//         "tutor_accepted",
//         "tutor_user_approved",
//         "tutor_hired",
//       ].includes(notif.type)
//     ) {
//       return (
//         <Button
//           className="usernotification-view-btn"
//           size="sm"
//           onClick={() => handleViewClick(notif)}
//         >
//           {/* View */}
//           {t("notifications.view")}
//         </Button>
//       );
//     } else if (
//       notif.type === "order_cancelled" ||
//       notif.type === "penalty_applied"
//     ) {
//       return null;
//     } else {
//       return (
//         <Button
//           className="usernotification-view-btn"
//           size="sm"
//           onClick={() => handleViewClick(notif)}
//         >
//           {/* View */}
//           {t("notifications.view")}
//         </Button>
//       );
//     }
//   };

//   const handleExtendClick = (notif) => {
//     let serviceType = "";
//     if (notif.orderNumber.startsWith("PS-")) {
//       serviceType = "plumber";
//     } else if (notif.orderNumber.startsWith("ES-")) {
//       serviceType = "electrician";
//     } else if (notif.orderNumber.startsWith("HS-")) {
//       serviceType = "home cleaning";
//     }
//     else if (notif.orderNumber.startsWith("GS-")) {
//       serviceType = "gas chula";
//     }
//     else if (notif.orderNumber.startsWith("AS-")) {
//       serviceType = "ac service";
//     }
//     else if (notif.orderNumber.startsWith("FS-")) {
//       serviceType = "filter";
//     }
//     else if (notif.orderNumber.startsWith("TS-")) {
//       serviceType = "tutor service";
//     }

//     if (!serviceType) {
//       // alert("Unable to determine service type for this order.");
//       alert(t("notifications.errors.invalid_service_type"));
//       return;
//     }

//     setSelectedOrderInfo({ orderId: notif.orderNumber, serviceType });
//     setModalOpen(true);
//   };

//   const handleViewClick = (notif) => {
//     if (notif.orderNumber) {
//       navigate(`/profile/orderhistory/${notif.orderNumber}`);
//     } else {
//       navigate(`/profile/orderhistory/`);
//     }
//   };

//   const handleModalClose = () => {
//     setModalOpen(false);
//   };

//   const handleExtensionSuccess = (newDeadline) => {
//     setNotifications((prev) =>
//       prev.filter((notif) => notif.orderNumber !== selectedOrderInfo.orderId)
//     );
//   };

//   const filteredNotifications = notifications.filter((notif) => {
//     if (activeTab === "all") return true;
//     if (activeTab === "unread") return !notif.isRead;
//     if (activeTab === "orders")
//       return [
//         // notif.type === "order_accepted" || notif.type === "order_cancelled"
//         "order_accepted",
//         "order_in_progress",
//         "order_completed",
//         "order_cancelled",
//         "tutor_accepted",
//         "tutor_user_approved",
//         "tutor_hired",
//         "order_rescheduled",
//         "order_reordered",
//       ].includes(notif.type);
//     if (activeTab === "service") return notif.type === "service_update";
//     if (activeTab === "system") return notif.type === "system";
//     return true;
//   });

//   const markAllAsRead = async () => {
//     for (let notif of notifications) {
//       if (!notif.isRead) {
//         await markNotificationAsRead(notif.Id);
//       }
//     }
//   };

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <>
//       <Navbar />

//       <Loader show={loading} />

//       <Container className="usernotificationpage-container">
//         {/* Page Header */}
//         <Row>
//           <Col>
//             <Card className="mb-3">
//               <CardBody className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0 fw-semibold">
//                   {/* Notifications */}
//                   {t("notifications.title")}
//                 </h5>
//                 <Button
//                   className="usernotification-btn-markallread btn-sm"
//                   onClick={markAllAsRead}
//                 >
//                   <i className="fas fa-check-double me-1"></i>
//                   {/* Mark all as read */}
//                   {t("notifications.mark_all_as_read")}
//                 </Button>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//         {/* Filter Tabs */}
//         <Row>
//           <Col>
//             <div className="d-flex flex-wrap gap-2 mb-3 usernotification-filter">
//               <Button
//                 color={activeTab === "all" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("all")}
//               >
//                 {/* All */}
//                 {t("notifications.filter_all")}
//               </Button>
//               <Button
//                 color={activeTab === "unread" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("unread")}
//               >
//                 {/* Unread */}
//                 {t("notifications.filter_unread")}
//               </Button>
//               <Button
//                 color={activeTab === "orders" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("orders")}
//               >
//                 {/* Orders */}
//                 {t("notifications.filter_orders")}
//               </Button>
//               <Button
//                 color={activeTab === "service" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("service")}
//               >
//                 {/* Services */}
//                 {t("notifications.filter_services")}
//               </Button>
//               <Button
//                 color={activeTab === "system" ? "primary" : "outline-primary"}
//                 size="sm"
//                 onClick={() => handleTabClick("system")}
//               >
//                 {/* System */}
//                 {t("notifications.filter_system")}
//               </Button>
//             </div>
//           </Col>
//         </Row>
//         {/* Notifications List */}
//         <Row>
//           <Col>
//             <Card className="usernotification-container">
//               <CardBody>
//                 {filteredNotifications.length > 0 ? (
//                   <ListGroup>
//                     {filteredNotifications.map((notif) => {
//                       const {
//                         iconClass,
//                         displayTitle,
//                         messageKey,
//                         messageParams,
//                         iconBgClass,
//                       } = getNotificationIconAndTitle(notif, t);

//                       let message;
//                       if (notif.type === "order_updated") {
//                         // CHANGE: Added fallback to raw message if parsing fails
//                         const base = t("notifications.messages.order_updated", {
//                           orderNumber: notif.orderNumber,
//                         });
//                         const parts = [];
//                         if (notif.priceDelta) {
//                           parts.push(
//                             t("notifications.messages.price_increase_part", {
//                               priceDelta: notif.priceDelta,
//                               newTotal:
//                                 notif.newTotal || t("notifications.unknown"),
//                             })
//                           );
//                         }
//                         if (notif.minutesAdded) {
//                           const pluralSuffix =
//                             notif.minutesAdded === 1 ? "_one" : "_other";
//                           parts.push(
//                             t(
//                               `notifications.messages.time_extension_part${pluralSuffix}`,
//                               {
//                                 minutesAdded: notif.minutesAdded,
//                                 newDeadline:
//                                   notif.newDeadline ||
//                                   t("notifications.unknown"),
//                               }
//                             )
//                           );
//                         }
//                         message =
//                           parts.length > 0
//                             ? base + ": " + parts.join(" , ") + "."
//                             : notif.message || base + "."; // Fallback to raw message
//                         console.log(
//                           "Constructed order_updated message:",
//                           message,
//                           "Parts:",
//                           parts
//                         );
//                       } else {
//                         message = t(messageKey, {
//                           ...messageParams,
//                           defaultValue: notif.message,
//                         });
//                       }

//                       return (
//                         <ListGroupItem
//                           key={notif.Id}
//                           className={`usernotification-item position-relative ${
//                             notif.isRead ? "" : "usernotification-unread"
//                           }`}
//                           onClick={() => markNotificationAsRead(notif.Id)}
//                         >
//                           <div className="d-flex justify-content-between align-items-start w-100">
//                             {/* Left side: icon + text */}
//                             <div className="d-flex align-items-start">
//                               {/* Notice we apply iconBgClass here */}
//                               <div
//                                 className={`usernotification-icon-wrapper ${iconBgClass} me-2`}
//                               >
//                                 <i className={iconClass}></i>
//                               </div>
//                               <div className="usernotification-content">
//                                 <div className="usernotification-title fw-semibold">
//                                   {displayTitle}
//                                 </div>
//                                 <div className="usernotification-message">
//                                   {/* {notif.message} */}
//                                   {/* {t(messageKey, messageParams)} */}
//                                   {/* {t(messageKey, {
//                                     ...messageParams,
//                                     defaultValue: notif.message,
//                                   })} */}

//                                   {/* {notif.message || ""}  */}

//                                   {message}
//                                 </div>
//                                 <div className="usernotification-time">
//                                   {timeSince(notif.created_at)}
//                                 </div>
//                               </div>
//                             </div>

//                             {/* Right side: action buttons */}
//                             <div className="d-flex align-items-center gap-2">
//                               {renderActionButton(notif)}
//                             </div>
//                           </div>
//                         </ListGroupItem>
//                       );
//                     })}
//                   </ListGroup>
//                 ) : (
//                   <p className="text-center mb-0">
//                     {/* No notifications found */}
//                     {t("notifications.no_notifications")}
//                   </p>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//       {/* Extend Time Modal */}
//       {modalOpen && selectedOrderInfo && (
//         <ExtendTimeModal
//           orderId={selectedOrderInfo.orderId}
//           serviceType={selectedOrderInfo.serviceType}
//           onClose={handleModalClose}
//           onExtensionSuccess={handleExtensionSuccess}
//         />
//       )}
//     </>
//   );
// };

// export default NotificationsPage;










// ***** New update with loader and 10 data limit (19-Oct-2025) ***** //
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem,
  Spinner as RSSpinner,
} from "reactstrap";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Navbar from "../../../Components/Navbar";
import { URL } from "../../../config";
import ExtendTimeModal from "../Modal/ExtendTimeModal";
import "./notificationsPage.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../../../Components/LoaderSpin/Loader";

/* ---------- helpers ---------- */

// Normalize API payload (supports old array & new {data, hasMore} object)
const normalizeNotifResponse = (payload) => {
  if (Array.isArray(payload))
    return { data: payload, hasMore: false, page: 1, limit: payload.length || 0 };
  if (Array.isArray(payload?.data))
    return {
      data: payload.data,
      hasMore: Boolean(payload.hasMore),
      page: Number(payload.page) || 1,
      limit: Number(payload.limit) || 10,
    };
  return { data: [], hasMore: false, page: 1, limit: 0 };
};

// relative time
function timeSince(dateString) {
  const date = new Date(dateString);
  const seconds = Math.floor((new Date() - date) / 1000);
  if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days !== 1 ? "s" : ""} ago`;
}


const deriveFullBuildingStatus = (notif) => {
  const msg = (notif.message || "").toLowerCase();

  if (!msg) return "";

  if (msg.includes("pending")) return "pending";
  if (msg.includes("under review")) return "in_review";
  if (msg.includes("scheduled site visit") || msg.includes("site visit")) {
    // if you're using specific wording for site visit
    return "site_visit_scheduled";
  }
  if (msg.includes("quotation") && msg.includes("shared")) {
    return "quotation_shared";
  }
  if (msg.includes("approved")) return "approved";
  if (msg.includes("completed")) return "completed";
  if (msg.includes("cancelled") || msg.includes("canceled")) return "cancelled";

  return "";
};

const DEFAULT_CANCEL_LIMIT = 3;

// icon/title/message mapping
const getNotificationIconAndTitle = (notif, t) => {
  switch (notif.type) {
    case "deadline_warning_pending":
      return {
        iconClass: "fas fa-exclamation-triangle",
        displayTitle: t("notifications.deadline_warning"),
        messageKey: "notifications.messages.deadline_warning_pending",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-warning",
      };
    case "order_accepted":
      return {
        iconClass: "fas fa-check-circle",
        displayTitle: t("notifications.order_accepted"),
        messageKey: "notifications.messages.order_accepted",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-green",
      };
    case "order_in_progress":
      return {
        iconClass: "fas fa-spinner fa-spin",
        displayTitle: t("notifications.order_in_progress"),
        messageKey:
          notif.recipientType === "user"
            ? "notifications.messages.order_in_progress_user"
            : "notifications.messages.order_in_progress_servitor",
        messageParams: {
          orderNumber: notif.orderNumber,
          servitorFirstName: notif.servitorFirstName || "Unknown",
          servitorLastName: notif.servitorLastName || "",
        },
        iconBgClass: "usernotification-icon-blue",
      };
    case "order_completed":
      return {
        iconClass: "fas fa-check",
        displayTitle: t("notifications.order_completed"),
        messageKey:
          notif.recipientType === "user"
            ? "notifications.messages.order_completed_user"
            : "notifications.messages.order_completed_servitor",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-green",
      };
    case "order_cancelled":
      return {
        iconClass: "fas fa-times-circle",
        displayTitle: t("notifications.order_cancelled"),
        messageKey: notif.message.includes("no servitor acceptance")
          ? "notifications.messages.order_cancelled_timeout"
          : notif.message.includes("cancelled by the servitor")
            ? "notifications.messages.order_cancelled_by_servitor"
            : notif.message.includes("cancelled by the user")
              ? "notifications.messages.order_cancelled_by_user"
              : "notifications.messages.order_cancelled_missed_deadline",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-red",
      };

      case "order_created_by_admin": {
        const serviceTypeFromMeta =
          notif.meta?.serviceType || notif.services_name || notif.serviceType;

        const serviceTypeFromMessage = (() => {
          const m = (notif.message || "").match(/placed your\s+(.+?)\s+order/i);
          return m ? m[1] : "";
        })();

        const serviceType =
          serviceTypeFromMeta || serviceTypeFromMessage || t("notifications.unknown");

        return {
          iconClass: "fas fa-shopping-cart",
          displayTitle: t("notifications.order_created_by_admin", { defaultValue: "Order Created" }),
          messageKey: "notifications.messages.order_created_by_admin",
          messageParams: {
            serviceType,
            orderNumber: notif.orderNumber || "",
          },
          iconBgClass: "usernotification-icon-green",
        };
      }


    case "penalty_applied":
      return {
        iconClass: "fas fa-exclamation-circle",
        displayTitle: t("notifications.penalty_applied"),
        messageKey: "notifications.messages.penalty_applied",
        messageParams: {
          orderNumber: notif.orderNumber,
          penaltyAmount: notif.penaltyAmount || 40,
        },
        iconBgClass: "usernotification-icon-red",
      };
    case "deadline_extended":
      return {
        iconClass: "fas fa-clock",
        displayTitle: t("notifications.deadline_extended"),
        messageKey: "notifications.messages.deadline_extended",
        messageParams: {
          orderNumber: notif.orderNumber,
          newDeadline: notif.newDeadline || t("notifications.unknown"),
        },
        iconBgClass: "usernotification-icon-purple",
      };
    case "account_blocked":
      return {
        iconClass: "fas fa-ban",
        displayTitle: t("notifications.account_blocked"),
        messageKey: "notifications.messages.account_blocked",
        messageParams: {
          penaltyCount: notif.penaltyCount || 3,
          // penaltyAmount: notif.penaltyAmount || 90,
          limit: notif.limit ?? DEFAULT_CANCEL_LIMIT,

        },
        iconBgClass: "usernotification-icon-red",
      };
    case "order_cancelled_with_penalty":
      return {
        iconClass: "fas fa-times-circle",
        displayTitle: t("notifications.order_cancelled_with_penalty"),
        messageKey: "notifications.messages.order_cancelled_with_penalty",
        messageParams: {
          orderNumber: notif.orderNumber,
          penaltyAmount: notif.penaltyAmount || 30,
          penaltyCount: notif.penaltyCount || 1,
          limit: notif.limit ?? DEFAULT_CANCEL_LIMIT,

        },
        iconBgClass: "usernotification-icon-red",
      };
    case "order_updated":
      return {
        iconClass: "fas fa-sync-alt",
        displayTitle: t("notifications.order_updated"),
        messageKey: "notifications.messages.order_updated",
        messageParams: {
          orderNumber: notif.orderNumber,
          priceDelta: notif.priceDelta,
          newTotal: notif.newTotal,
          minutesAdded: notif.minutesAdded,
          newDeadline: notif.newDeadline ? notif.newDeadline : undefined,
        },
        iconBgClass: "usernotification-icon-blue",
      };
    case "order_rescheduled": {
      const m1 = notif.message?.match(/rescheduled to\s*(.+?)\.?$/i);
      const m2 = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
      const m3 = notif.message?.match(/\(new deadline:\s*(.+?)\)/i);
      const newSchedule =
        (m1 && m1[1]) ||
        (m2 && m2[1]) ||
        (m3 && m3[1]) ||
        t("notifications.unknown");
      return {
        iconClass: "fas fa-clock",
        displayTitle: t("notifications.order_rescheduled"),
        messageKey: "notifications.messages.order_rescheduled",
        messageParams: { orderNumber: notif.orderNumber, newSchedule },
        iconBgClass: "usernotification-icon-purple",
      };
    }
    case "order_reordered": {
      const m = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
      const newSchedule = (m && m[1]) || t("notifications.unknown");
      return {
        iconClass: "fas fa-sync-alt",
        displayTitle: t("notifications.order_reordered"),
        messageKey: "notifications.messages.order_reordered",
        messageParams: { orderNumber: notif.orderNumber, newSchedule },
        iconBgClass: "usernotification-icon-blue",
      };
    }

    case "order_assigned":
      return {
        iconClass: "fas fa-user-plus",
        displayTitle: t("notifications.order_assigned"), // small title above message
        messageKey: "notifications.messages.order_assigned",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-blue", // or green if you prefer
      };

    case "tutor_accepted":
      return {
        iconClass: "fas fa-user-check",
        displayTitle: t("notifications.tutor_accepted"),
        messageKey: "notifications.messages.tutor_accepted",
        messageParams: {
          orderNumber: notif.orderNumber,
          servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
          servitorLastName: notif.servitorLastName || "",
        },
        iconBgClass: "usernotification-icon-blue",
      };
    case "tutor_user_approved":
      return {
        iconClass: "fas fa-user-check",
        displayTitle: t("notifications.tutor_user_approved"),
        messageKey: "notifications.messages.tutor_user_approved",
        messageParams: {
          orderNumber: notif.orderNumber,
          servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
          servitorLastName: notif.servitorLastName || "",
        },
        iconBgClass: "usernotification-icon-green",
      };
    case "tutor_hired":
      return {
        iconClass: "fas fa-user-tie",
        displayTitle: t("notifications.tutor_hired"),
        messageKey: "notifications.messages.tutor_hired",
        messageParams: {
          orderNumber: notif.orderNumber,
          servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
          servitorLastName: notif.servitorLastName || "",
        },
        iconBgClass: "usernotification-icon-purple",
      };
    case "reward_points_awarded":
      return {
        iconClass: "fas fa-trophy",
        displayTitle: t("notifications.reward_points_awarded"),
        messageKey:
          notif.recipientType === "servitor"
            ? "notifications.messages.reward_points_awarded_servitor"
            : "notifications.messages.reward_points_awarded_user",
        messageParams: {
          orderNumber: notif.orderNumber || t("notifications.unknown"),
          // points: notif.rewardPoints,
          count: notif.rewardPoints,
        },
        iconBgClass: "usernotification-icon-blue",
      };
    // case "reward_claimed":
    //   return {
    //     messageKey: "notifications.messages.reward_claimed_coupon",
    //     messageParams: {
    //       code: notif.code || t("notifications.unknown"),
    //       tierLabel: notif.tierLabel || t("notifications.unknown"),
    //       discountValue: notif.discountValue,
    //       remainingPoints: typeof notif.remainingPoints === "number"
    //         ? notif.remainingPoints
    //         : t("notifications.unknown"),
    //     },
    //     iconBgClass: "usernotification-icon-green",
    //   };

    case "reward_claimed":
      return {
        iconClass: "fas fa-gift",
        displayTitle: t("notifications.reward_claimed_coupon_title", {
          defaultValue: "Coupon Claimed",
        }),
        messageKey: "notifications.messages.reward_claimed_coupon",
        messageParams: {
          code: notif.code || t("notifications.unknown"),
          tierLabel: notif.tierLabel || t("notifications.unknown"),
          discountValue:
            typeof notif.discountValue === "number"
              ? notif.discountValue
              : t("notifications.unknown"),
          remainingPoints:
            typeof notif.remainingPoints === "number"
              ? notif.remainingPoints
              : t("notifications.unknown"),
        },
        iconBgClass: "usernotification-icon-green",
      };



    case "report_received":
      return {
        iconClass: "fas fa-life-ring",
        displayTitle: t("notifications.report_received"),
        messageKey: "notifications.messages.report_received",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-blue", // or green if you prefer
      };

    case "report_opened_counterparty":
      return {
        iconClass: "fas fa-flag",
        displayTitle: t("notifications.report_opened_counterparty"),
        messageKey: "notifications.messages.report_opened_counterparty",
        messageParams: { orderNumber: notif.orderNumber },
        iconBgClass: "usernotification-icon-purple",
      };

    case "report_closed": {
      const raw = notif.status || notif.message?.match?.(/\bis (\w+)\b/i)?.[1] || "resolved";
      const statusLabel = t(`notifications.status.${raw}`, raw);

      return {
        iconClass: "fas fa-life-ring",
        displayTitle: t("notifications.report_closed"), // keep same pattern as report_received
        messageKey: "notifications.messages.report_closed",
        messageParams: { orderNumber: notif.orderNumber, status: statusLabel },
        iconBgClass: "usernotification-icon-green",
      };
    }


    /* 🔹 NEW: full building request created */
    case "full_building_request_created":
      return {
        iconClass: "fas fa-building",
        displayTitle: t("notifications.full_building_request_created_title", {
          defaultValue: "Full Building Request",
        }),
        messageKey: "notifications.messages.full_building_request_created",
        messageParams: {
          orderNumber: notif.orderNumber || t("notifications.unknown"),
        },
        iconBgClass: "usernotification-icon-blue",
      };

    /* 🔹 NEW: full building status updated */
    case "full_building_status_updated": {
      let raw = (notif.status || "").toLowerCase();
      if (!raw) {
        raw = deriveFullBuildingStatus(notif); // 🔹 same fallback
      }

      const statusLabel = raw
        ? t(`notifications.full_building_status.${raw}`, { defaultValue: raw })
        : t("notifications.unknown");

      return {
        iconClass: "fas fa-building",
        displayTitle: t("notifications.full_building_status_updated_title", {
          defaultValue: "Full Building Status",
        }),
        messageKey: "notifications.messages.full_building_status_updated",
        messageParams: {
          orderNumber: notif.orderNumber || t("notifications.unknown"),
          status: statusLabel,
        },
        iconBgClass: "usernotification-icon-purple",
      };
    }



    default:
      return {
        iconClass: "fas fa-info-circle",
        displayTitle: t("notifications.notification_default"),
        messageKey:
          notif.type === "service_update"
            ? "notifications.messages.service_update"
            : notif.type === "system"
              ? "notifications.messages.system"
              : "notifications.messages.notification_default",
        messageParams: { orderNumber: notif.orderNumber || "" },
        iconBgClass: "usernotification-icon-default",
      };
  }
};

/* ---------- component ---------- */

const NotificationsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [userId, setUserId] = useState(null);

  // data & UI
  const [notifications, setNotifications] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [loadingInitial, setLoadingInitial] = useState(true);

  // pagination / infinite scroll
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const sentinelRef = useRef(null);

  // extend/view state
  const [selectedOrderInfo, setSelectedOrderInfo] = useState(null);

  // derive user id once
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUserId(null);
      setLoadingInitial(false);
      return;
    }
    try {
      const decoded = jwtDecode(token);
      const uid = decoded.Id?.startsWith?.("user-")
        ? decoded.Id.split("user-")[1]
        : decoded.Id;
      setUserId(uid);
    } catch {
      setUserId(null);
    }
  }, []);

  // reset & refetch when userId changes
  useEffect(() => {
    setNotifications([]);
    setPage(1);
    setHasMore(true);
  }, [userId]);

  // fetch page
  const fetchPage = useCallback(async () => {
    if (!userId || !hasMore) return;

    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", "10");

    try {
      if (page === 1) setLoadingInitial(true);
      else setLoadingMore(true);

      const res = await fetch(`${URL}/notifications/user/${userId}?${params.toString()}`);
      if (!res.ok) throw new Error("Failed to fetch notifications");
      const json = await res.json();

      const { data: incomingRaw, hasMore: nextHasMore } = normalizeNotifResponse(json);

      // enhance/parse each notif (your logic)
      const enhancedIncoming = await Promise.all(
        incomingRaw.map(async (notif) => {
          let penaltyAmount,
            penaltyCount,
            newDeadline,
            servitorFirstName,
            servitorLastName,
            newTotal,
            priceDelta,
            minutesAdded,
            rewardPoints,
            claimAmount,
            claimRef;

          if (notif.type === "penalty_applied") {
            const match = notif.message?.match?.(/A penalty of (\d+) taka/);
            penaltyAmount = match ? parseInt(match[1], 10) : 40;
          } else if (notif.type === "order_cancelled_with_penalty") {
            // old patterns
            const countMatchOld = notif.message?.match?.(/Cancellation count:\s*(\d+)/i);

            // NEW pattern: "Count: 2/3"
            const countMatchNew = notif.message?.match?.(/Count:\s*(\d+)\s*\/\s*(\d+)/i);

            penaltyCount =
              typeof notif.penaltyCount === "number"
                ? notif.penaltyCount
                : countMatchNew
                  ? parseInt(countMatchNew[1], 10)
                  : countMatchOld
                    ? parseInt(countMatchOld[1], 10)
                    : 1;

            notif.limit =
              typeof notif.limit === "number"
                ? notif.limit
                : countMatchNew
                  ? parseInt(countMatchNew[2], 10)
                  : DEFAULT_CANCEL_LIMIT;
          } else if (notif.type === "account_blocked") {
            const m = notif.message?.match?.(/\((\d+)\s*\/\s*(\d+)\)/);
            penaltyCount = typeof notif.penaltyCount === "number" ? notif.penaltyCount : (m ? parseInt(m[1], 10) : 3);
            notif.limit = typeof notif.limit === "number" ? notif.limit : (m ? parseInt(m[2], 10) : DEFAULT_CANCEL_LIMIT);
          } else if (notif.type === "deadline_extended") {
            const match = notif.message?.match?.(/extended to (.+)\./);
            newDeadline = match ? match[1] : null;
          } else if (notif.type === "order_in_progress" && notif.recipientType === "user") {
            if (notif.servitorId) {
              try {
                const cleanId = String(notif.servitorId).includes("servitor-")
                  ? notif.servitorId.split("servitor-")[1]
                  : notif.servitorId;
                const servitorResponse = await axios.get(`${URL}/servitors/${cleanId}`);
                if (servitorResponse.status === 200) {
                  const s = servitorResponse.data;
                  servitorFirstName = s.FirstName || "Unknown";
                  servitorLastName = s.LastName || "";
                } else {
                  const m = notif.message?.match?.(/accepted by ([^\s]+)\s*([^\s]*)/);
                  servitorFirstName = m ? m[1] : "Unknown";
                  servitorLastName = m ? m[2] : "";
                }
              } catch {
                const m = notif.message?.match?.(/accepted by ([^\s]+)\s*([^\s]*)/);
                servitorFirstName = m ? m[1] : "Unknown";
                servitorLastName = m ? m[2] : "";
              }
            } else {
              const m = notif.message?.match?.(/accepted by ([^\s]+)\s*([^\s]*)/);
              servitorFirstName = m ? m[1] : "Unknown";
              servitorLastName = m ? m[2] : "";

            }
          } else if (notif.type === "order_updated") {
            const deltaMatch = notif.message?.match(/(?:increased|updated) by\s*(\d+)\s*tk/i);
            const totalMatch = notif.message?.match(/(?:New total price|New total)\s*(\d+)\s*tk/i);
            const minutesMatch = notif.message?.match(/extended by\s*(\d+)\s*minute?s?/i);
            const toMatch = notif.message?.match(/new deadline:\s*(.*?)(?:\)|$)/i);
            priceDelta = deltaMatch ? parseInt(deltaMatch[1], 10) : undefined;
            newTotal = totalMatch ? parseInt(totalMatch[1], 10) : undefined;
            minutesAdded = minutesMatch ? parseInt(minutesMatch[1], 10) : undefined;
            newDeadline = toMatch ? toMatch[1] : undefined;
          }

          if (notif.type === "reward_points_awarded") {
            if (typeof notif.rewardPoints === "number") {
              rewardPoints = notif.rewardPoints;
            } else {
              const m = notif.message?.match(/earned\s+(\d+)\s+(?:reward\s+)?points?/i);
              rewardPoints = m ? parseInt(m[1], 10) : undefined;
            }
          }

          if (notif.type === "reward_claimed") {
            const baseDiscount = notif.discountValue ?? notif.meta?.discountValue;
            const baseTier = notif.tierLabel ?? notif.meta?.tierLabel;
            const baseCode = notif.code ?? notif.meta?.code;
            const baseRemaining = notif.remainingPoints ?? notif.meta?.remainingPoints;

            const msg = notif.message || "";

            // Support both “discount 20 tk” and “worth 20 tk”
            const amountMatch = msg.match(
              /(?:discount|worth)\s*(\d+)\s*tk/i
            );
            const codeMatch = msg.match(/\(([A-Za-z0-9-]+)\)\s*claimed/i);
            const tierMatch = msg.match(/^([^)]+?)\s*Coupon/i);
            const remainingMatch = msg.match(/(\d+)\s*points?\s*remain/i);

            const dv2 =
              typeof baseDiscount === "number"
                ? baseDiscount
                : amountMatch
                  ? parseInt(amountMatch[1], 10)
                  : undefined;

            const cd2 = baseCode || (codeMatch ? codeMatch[1] : undefined);
            const tl2 = baseTier || (tierMatch ? tierMatch[1] : undefined);
            const rp2 =
              typeof baseRemaining === "number"
                ? baseRemaining
                : remainingMatch
                  ? parseInt(remainingMatch[1], 10)
                  : undefined;

            notif.discountValue = dv2;
            notif.tierLabel = tl2;
            notif.code = cd2;
            notif.remainingPoints = rp2;
          }


          return {
            ...notif,
            penaltyAmount,
            penaltyCount,
            newDeadline,
            servitorFirstName,
            servitorLastName,
            priceDelta,
            newTotal,
            minutesAdded,
            rewardPoints,
            claimAmount,
            claimRef,
          };
        })
      );

      setNotifications((prev) => (page === 1 ? enhancedIncoming : [...prev, ...enhancedIncoming]));
      setHasMore(nextHasMore);
    } catch (e) {
      console.error("Error fetching notifications:", e);
      setHasMore(false);
    } finally {
      setLoadingInitial(false);
      setLoadingMore(false);
    }
  }, [userId, page, hasMore]);

  // load on mount & when page changes
  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  // infinite scroll observer
  useEffect(() => {
    if (!sentinelRef.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingMore && hasMore && !loadingInitial) {
          setPage((p) => p + 1);
        }
      },
      { rootMargin: "200px" }
    );
    obs.observe(sentinelRef.current);
    return () => obs.disconnect();
  }, [loadingMore, hasMore, loadingInitial]);

  // mark single as read
  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await fetch(`${URL}/notifications/${notificationId}/read`, {
        method: "PATCH",
      });
      if (response.ok) {
        setNotifications((prev) =>
          prev.map((notif) => (notif.Id === notificationId ? { ...notif, isRead: true } : notif))
        );
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  // action buttons
  const handleExtendClick = (notif) => {
    let serviceType = "";
    if (notif.orderNumber?.startsWith("PS-")) serviceType = "plumber";
    else if (notif.orderNumber?.startsWith("ES-")) serviceType = "electrician";
    else if (notif.orderNumber?.startsWith("HS-")) serviceType = "home cleaning";
    else if (notif.orderNumber?.startsWith("GS-")) serviceType = "gas chula";
    else if (notif.orderNumber?.startsWith("AS-")) serviceType = "ac service";
    else if (notif.orderNumber?.startsWith("FS-")) serviceType = "filter";
    else if (notif.orderNumber?.startsWith("TS-")) serviceType = "tutor service";

    if (!serviceType) {
      alert(t("notifications.errors.invalid_service_type"));
      return;
    }
    setSelectedOrderInfo({ orderId: notif.orderNumber, serviceType });
    setModalOpen(true);
  };

  const handleViewClick = (notif) => {
    if (notif.orderNumber) navigate(`/profile/orderhistory/${notif.orderNumber}`);
    else navigate(`/profile/orderhistory/`);
  };

  const handleModalClose = () => setModalOpen(false);
  const handleExtensionSuccess = () => {
    setNotifications((prev) =>
      prev.filter((notif) => notif.orderNumber !== (selectedOrderInfo?.orderId || ""))
    );
  };

  const markAllAsRead = async () => {
    for (let notif of notifications) {
      if (!notif.isRead) {
        // eslint-disable-next-line no-await-in-loop
        await markNotificationAsRead(notif.Id);
      }
    }
  };

  return (
    <>
      <Navbar />
      <Loader show={loadingInitial} />

      <Container className="usernotificationpage-container">
        {/* Page Header */}
        <Row>
          <Col>
            <Card className="mb-3">
              <CardBody className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0 fw-semibold">{t("notifications.title")}</h5>
                <Button className="usernotification-btn-markallread btn-sm" onClick={markAllAsRead}>
                  <i className="fas fa-check-double me-1"></i>
                  {t("notifications.mark_all_as_read")}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Notifications List */}
        <Row>
          <Col>
            <Card className="usernotification-container">
              <CardBody>
                {notifications.length > 0 ? (
                  <ListGroup>
                    {notifications.map((notif) => {
                      const {
                        iconClass,
                        displayTitle,
                        messageKey,
                        messageParams,
                        iconBgClass,
                      } = getNotificationIconAndTitle(notif, t);

                      let message;
                      if (notif.type === "order_updated") {
                        const base = t("notifications.messages.order_updated", {
                          orderNumber: notif.orderNumber,
                        });
                        const parts = [];
                        if (notif.priceDelta) {
                          parts.push(
                            t("notifications.messages.price_increase_part", {
                              priceDelta: notif.priceDelta,
                              newTotal: notif.newTotal || t("notifications.unknown"),
                            })
                          );
                        }
                        if (notif.minutesAdded) {
                          const pluralSuffix =
                            notif.minutesAdded === 1 ? "_one" : "_other";
                          parts.push(
                            t(
                              `notifications.messages.time_extension_part${pluralSuffix}`,
                              {
                                minutesAdded: notif.minutesAdded,
                                newDeadline: notif.newDeadline || t("notifications.unknown"),
                              }
                            )
                          );
                        }
                        message =
                          parts.length > 0
                            ? `${base}: ${parts.join(" , ")}.`
                            : notif.message || `${base}.`;
                      } else {
                        message = t(messageKey, {
                          ...messageParams,
                          defaultValue: notif.message,
                        });
                      }

                      return (
                        <ListGroupItem
                          key={notif.Id}
                          className={`usernotification-item position-relative ${notif.isRead ? "" : "usernotification-unread"
                            }`}
                          onClick={() => markNotificationAsRead(notif.Id)}
                        >
                          <div className="d-flex justify-content-between align-items-start w-100">
                            {/* Left: icon + text */}
                            <div className="d-flex align-items-start">
                              <div
                                className={`usernotification-icon-wrapper ${iconBgClass} me-2`}
                              >
                                <i className={iconClass}></i>
                              </div>
                              <div className="usernotification-content">
                                <div className="usernotification-title fw-semibold">
                                  {displayTitle}
                                </div>
                                <div className="usernotification-message">
                                  {message}
                                </div>
                                <div className="usernotification-time">
                                  {timeSince(notif.created_at)}
                                </div>
                              </div>
                            </div>

                            {/* Right: action buttons (only when relevant) */}
                            <div className="d-flex align-items-center gap-2">
                              {(() => {
                                if (notif.type === "deadline_warning_pending") {
                                  return (
                                    <Button
                                      className="usernotification-extend-btn"
                                      size="sm"
                                      onClick={() => handleExtendClick(notif)}
                                    >
                                      {t("notifications.extend_time")}
                                    </Button>
                                  );
                                }
                                if (
                                  [
                                    "order_accepted",
                                    "order_in_progress",
                                    "order_completed",
                                    "tutor_accepted",
                                    "tutor_user_approved",
                                    "tutor_hired",
                                  ].includes(notif.type)
                                ) {
                                  return (
                                    <Button
                                      className="usernotification-view-btn"
                                      size="sm"
                                      onClick={() => handleViewClick(notif)}
                                    >
                                      {t("notifications.view")}
                                    </Button>
                                  );
                                }
                                if (
                                  notif.type === "order_cancelled" ||
                                  notif.type === "penalty_applied" ||
                                  notif.type === "full_building_request_created" ||
                                  notif.type === "full_building_status_updated" ||
                                  notif.type === "order_created_by_admin"
                                ) {
                                  return null;
                                }
                                return (
                                  <Button
                                    className="usernotification-view-btn"
                                    size="sm"
                                    onClick={() => handleViewClick(notif)}
                                  >
                                    {t("notifications.view")}
                                  </Button>
                                );
                              })()}
                            </div>
                          </div>
                        </ListGroupItem>
                      );
                    })}
                  </ListGroup>
                ) : (
                  !loadingInitial && (
                    <p className="text-center mb-0">
                      {t("notifications.no_notifications")}
                    </p>
                  )
                )}

                {/* Infinite scroll sentinel */}
                {hasMore && !loadingInitial && (
                  <div
                    ref={sentinelRef}
                    className="usernotification-sentinel text-center py-3"
                  >
                    {loadingMore && <RSSpinner size="sm" />}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Extend Time Modal */}
      {modalOpen && selectedOrderInfo && (
        <ExtendTimeModal
          orderId={selectedOrderInfo.orderId}
          serviceType={selectedOrderInfo.serviceType}
          onClose={handleModalClose}
          onExtensionSuccess={handleExtensionSuccess}
        />
      )}
    </>
  );
};

export default NotificationsPage;
